(function () {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProviderCategory', ProviderCategory);

    ProviderCategory.$inject = ['$resource', 'DateUtils'];

    function ProviderCategory($resource, DateUtils) {
        var resourceUrl = 'api/provider-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAllByCountry': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-countries/:id/categories'
            },
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-category-list'
            }
        });
    }
})();
